import { CommonModule } from '@angular/common';
import { Component, inject, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { DividerModule } from 'primeng/divider';
import { DrawerModule } from 'primeng/drawer';
import { UserService } from '@services/user.service';
import { SessionService } from '@utils/session.service';
import { UtilsService } from '@utils/utils.service';
import { ToastService } from '@utils/toast.service';

@Component({
  selector: 'app-update-bank-group',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule, MultiSelectModule, SelectModule, DividerModule, DrawerModule],
  templateUrl: './update-bank-group.component.html',
  styleUrl: './update-bank-group.component.scss',
})
export class UpdateBankGroupComponent implements OnChanges {
  @Input() id: any;
  @Output() saved = new EventEmitter<void>();
  private formBuilder = inject(FormBuilder);
  private userService = inject(UserService);
  private utils = inject(UtilsService);
  private sessionService = inject(SessionService);
  private toastService = inject(ToastService);

  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public onLoading = false;
  public isSaving = false;
  public listUsers: any[] = [];

  public form = this.formBuilder.group({
    NAME: [null, Validators.required],
    USERS: [null, Validators.required],
    BANK: this.formBuilder.group({
      BANCO: [null, Validators.required],
      TITULAR: [null, Validators.required],
      NUMERO_CUENTA: [null, Validators.required],
      CLABE: [null, [Validators.required, Validators.minLength(18), Validators.maxLength(18)]],
    }),
  });

  ngOnChanges(changes: SimpleChanges): void {
    const visibleStart = changes['visible'] && changes['visible'].currentValue === true;
    const idChanged = changes['id'] && this.id;

    if (idChanged || (visibleStart && this.id)) {
      this.loadUsers();
      this.loadBankGroupData();
    }
  }

  loadUsers(): void {
    const userId = this.sessionService.getUser()?.userId;

    this.userService.getUsersOfUser(Number(userId)).then((response: any) => {
      this.listUsers = response.childrens.map((user: any) => ({ label: user.nickname, value: user.userId }));
      this.listUsers = this.utils.orderArrayBy(this.listUsers, 'label');
    });
  }

  loadBankGroupData(): void {
    this.onLoading = true;

    this.userService
      .getBankGroup(this.id)
      .then((response: any) => {
        this.form.get('NAME')?.setValue(response.label);
        this.form.get('USERS')?.setValue(response.users);
        this.form.get('BANK')?.setValue(response.bank);
      })
      .finally(() => {
        this.onLoading = false;
      });
  }

  updateBankGroup(): void {
    this.isSaving = true;

    this.userService
      .updateBankGroup(this.id, this.form.value)
      .then(() => {
        this.toastService.success('Grupo de bancos actualizado con éxito.');
        this.saved.emit();
        this.closeDrawer();
      })
      .catch((error: any) => {
        this.toastService.error(error.error?.data?.message || 'Ocurrió un error al actualizar el grupo de bancos.');
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  public closeDrawer(): void {
    this.form.reset();
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
